import {
  Component,
  OnInit,
  Input,
  ViewChild,
  HostListener
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { ChartsDialogComponent } from "../charts-dialog/charts-dialog.component";
import "zone.js/dist/zone"; // Included with Angular CLI.
import "zone.js/dist/zone-error";

@Component({
  selector: "app-charts-expand",
  templateUrl: "./charts-expand.component.html",
  styleUrls: ["./charts-expand.component.css"]
})
export class ChartsExpandComponent implements OnInit {
  @Input("datasets") datasets;
  @Input("labels") labels;
  @Input("options") options;
  @Input("legend") legend;
  @Input("chartType") chartType;
  @Input("colors") colors;
  @Input("title") title;
  @Input("showChart") showChart;
  @Input("data") data;
  @Input("type") type;
  @ViewChild("chart") chart;
  @ViewChild("googleChart") googleChart;
  @Input("isCollapsable") isCollapsable;
  @Input("showExpand") showExpand;
  collapseChart: boolean = false;
  showGoogle: boolean = true;
  viewExpand: boolean = true;
  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    if (this.showExpand) {
      this.viewExpand = false;
    }
    if (this.showChart == undefined) {
      this.showChart = true;
    }
    if (this.type == undefined) {
      this.type = "chartsjs";
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.googleChart.redraw();
  }

  redraw() {
    this.googleChart.redraw();
  }

  openDialog() {
    const dialogRef = this.dialog.open(ChartsDialogComponent, {
      height: "80vh",
      width: "80vw",
      data: {
        datasets: this.datasets,
        labels: this.labels,
        options: this.options,
        legend: this.legend,
        chartType: this.chartType,
        colors: this.colors,
        title: this.title,
        data: this.data,
        type: this.type
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getChart() {
    return this.chart.nativeElement;
  }
}
